/* global Macy */
const masonryLayout = {
	el: {
		masonryContainer: document.querySelector('.areas-grid')
	},

	fxMasonry() {
		if (!this.el.masonryContainer) return

		const macy = new Macy({
			container: '.areas-grid',
			trueOrder: true,
			columns: 1,
			mobileFirst: true,
			margin: {
				x: 30,
				y: 50
			},
			breakAt: {
				1024: 2
			}
		})

		window.addEventListener('resize', () => macy.recalculate(true))
	},

	init() {
		this.fxMasonry()
	}
}

masonryLayout.init()